import styled from '@emotion/styled';
import { AdAnalyticsFilter, AdAnalyticsPlacementTypes, AdAnalyticsVideo } from '@kaizenplatform/hugot-entity';
// import DailyPerformanceList from './DailyPerformanceList';
import { Button, Divider as _Divider, Modal, Paper, TextField as _TextField, Typography } from '@material-ui/core';
import { List } from 'immutable';
import { createElement, FC, Fragment, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Language from '../../../entity/Language';
import Spinner from '../../component/compound/Spinner';
import { SCREEN_LARGE } from '../../constant/pageWidth';
import { SPACING_HUGE, SPACING_LARGE, SPACING_UNIT } from '../../constant/spacing';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';
import _Filters from './AdAnalyticsFilters';
import _AnalyticsItem from './AnalyticsItem';
import _AnalyticsList from './AnalyticsList';

type Props = {
  loading: boolean;
  language: Language;
  submitReport: boolean;
  analyticsVideos: List<AdAnalyticsVideo> | null;
  // dailyPerformance: List<AdAnalyticsDailyPerformance>;
  onUpdatePlacementTypes: ({ platformKey, mediaKey, placementKey, period }: AdAnalyticsFilter) => void;
  onSubmitPlacementTypes: () => void;
  tryCreateReport: ({ title }: { title: string }) => void;
  placementTypes: AdAnalyticsPlacementTypes | null;
  selectedPlacementTypes: AdAnalyticsFilter;
  onBackListPage: () => void;
  checkSubmitReport: () => void;
  onMount: () => void;
  onUnmount: () => void;
  className?: string;
};

const ShowAdAnalyticsPage: FC<Props> = ({
  loading,
  language,
  submitReport,
  analyticsVideos,
  // dailyPerformance,
  placementTypes,
  selectedPlacementTypes,
  onUpdatePlacementTypes,
  onSubmitPlacementTypes,
  tryCreateReport,
  onBackListPage,
  checkSubmitReport,
  onMount,
  onUnmount,
  className,
}: {
  loading: boolean;
  language: Language;
  submitReport: boolean;
  analyticsVideos: List<AdAnalyticsVideo> | null;
  // dailyPerformance: List<AdAnalyticsDailyPerformance>;
  placementTypes: AdAnalyticsPlacementTypes | null;
  selectedPlacementTypes: AdAnalyticsFilter;
  onUpdatePlacementTypes: ({ platformKey, mediaKey, placementKey, period }: AdAnalyticsFilter) => void;
  onSubmitPlacementTypes: () => void;
  tryCreateReport: ({ title }: { title: string }) => void;

  onBackListPage: () => void;
  checkSubmitReport: () => void;
  onMount: () => void;
  onUnmount: () => void;
  className?: string;
}) => {
  useEffect(() => {
    onMount();
    return () => {
      onUnmount();
    };
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [modalOpen, updateModalOpen] = useState(false);
  const [title, updateTitle] = useState('');
  // const handleOpenModal = () => {
  //   updateModalOpen(true);
  // };
  const handleCloseModal = () => {
    updateModalOpen(false);
    checkSubmitReport();
  };

  const runAnalyticsButton = (
    <SubmitButton
      color="primary"
      variant="contained"
      disabled={loading || title === ''}
      onClick={() => {
        tryCreateReport({ title: title });
      }}
    >
      <FormattedMessage id="adAnalytics_detail.button_submit_report" />
    </SubmitButton>
  );

  const submitPlacementTypeButton = (
    <Button color="primary" variant="contained" onClick={() => onSubmitPlacementTypes()}>
      <FormattedMessage id="adAnalytics_list.page_button_placements" />
    </Button>
  );
  // const openModalButton = (
  //   <Button color="primary" variant="contained" disabled={loading} onClick={handleOpenModal}>
  //     <FormattedMessage id="adAnalytics_detail.button_report" />
  //   </Button>
  // );

  return (
    <Root className={className}>
      <Title variant="h5">
        <FormattedMessage id="adAnalytics_detail.page_title" />
      </Title>
      <Container>
        <MenuWrapper>
          {loading ? (
            ''
          ) : (
            <Filters
              placementTypes={placementTypes}
              selectedPlacementTypes={selectedPlacementTypes}
              onUpdatePlacementTypes={onUpdatePlacementTypes}
            />
          )}
          {loading ? '' : submitPlacementTypeButton}
          {/* {openModalButton} */}
        </MenuWrapper>
        {loading ? (
          <Loading>
            <Spinner />
          </Loading>
        ) : (
          <>
            {analyticsVideos && analyticsVideos.size >= 1 ? (
              <>
                <AnalyticsList>
                  {analyticsVideos &&
                    analyticsVideos.map((analyticsVideo, index) => (
                      <Fragment key={`AnalyticsItem-${index}`}>
                        <AnalyticsItem analyticsVideo={analyticsVideo} language={language} />
                        <Divider />
                      </Fragment>
                    ))}
                </AnalyticsList>
                {/* <DailyTitle>
                  <FormattedMessage id="adAnalytics_detail.label_daily_performance" />
                </DailyTitle> */}
                {/* {dailyPerformance.size > 0 ? (
                  <>
                    <DailyPerformanceList dailyPerformance={dailyPerformance} />
                    <Divider />
                  </>
                ) : (
                  <FormattedMessage id="adAnalytics_detail.label_undefined_performance" />
                )} */}
              </>
            ) : (
              <EmptyState>
                <Typography variant="h6" align="center">
                  <FormattedMessage id="adAnalytics_detail.empty_state" />
                </Typography>
                <PageBackButton variant="contained" color="primary" onClick={() => onBackListPage()}>
                  <FormattedMessage id="adAnalytics_detail.page_back_button" />
                </PageBackButton>
              </EmptyState>
            )}
          </>
        )}
      </Container>
      <Modal open={modalOpen && !submitReport} onClose={handleCloseModal}>
        <ModalStyle>
          <ModalInput>
            <TextField label="title" onChange={(e) => updateTitle(e.target.value)} />
          </ModalInput>
          {runAnalyticsButton}
        </ModalStyle>
      </Modal>
    </Root>
  );
};

const Root = styled('section')({
  maxWidth: SCREEN_LARGE,
  margin: `0 auto ${SPACING_UNIT * 10}px`,
  paddingTop: `${SPACING_HUGE}px`,
});

const Container = styled(Paper)(
  gridLayoutContainer({
    columns: ['100%'],
    rows: ['auto'],
    areas: [['filter'], ['analytics']],
    alignItems: 'center',
  }),
  {
    width: 'auto',
    padding: SPACING_LARGE,
  },
);

const MenuWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: SPACING_LARGE,
  alignItems: 'start',
});

const Loading = styled('div')({
  padding: SPACING_HUGE,
});

const Title = styled(Typography)({
  marginBottom: SPACING_LARGE,
});

const Filters = styled(_Filters)(gridLayoutItem('filter'), {
  marginBottom: SPACING_LARGE,
});

const AnalyticsList = styled(_AnalyticsList)(gridLayoutItem('analytics'));

const AnalyticsItem = styled(_AnalyticsItem)({
  marginBottom: SPACING_HUGE,
});

const Divider = styled(_Divider)({
  marginBottom: SPACING_HUGE,
});

const EmptyState = styled('div')({
  padding: SPACING_HUGE,
  textAlign: 'center',
});

const PageBackButton = styled(Button)({
  marginTop: SPACING_LARGE,
});

// const DailyTitle = styled('div')({
//   fontSize: '20px',
//   color: 'rgba(0,0,0,.66)',
//   marginBottom: '32px',
//   fontWeight: 700,
// });

const ModalStyle = styled('div')({
  // シャドウと角丸つける
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '400',
  background: 'white',
  outline: 'none',
  boxShadow: '0 3px 7px rgba(0, 0, 0, 0.3)',
  borderRadius: '10px',
  border: '1px solid rgba(0, 0, 0, 0.3)',
  padding: '16px',
});

const ModalInput = styled('div')({
  marginBottom: '32px',
  maxHeight: '450px',
});

const SubmitButton = styled(Button)({
  width: '100%',
});

const TextField = styled(_TextField)({
  marginRight: '8px',
  width: '100%',
});

export default ShowAdAnalyticsPage;
